(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gestaspjall-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gs-chat').forEach((chat) => {
    const body = chat.querySelector('.gs-chat__body');
    const choices = chat.querySelector('.gs-chat__choices');
    const form = chat.querySelector('.gs-chat__input');
    const input = form.querySelector('input');
    const submit = form.querySelector('button');
    const reset = chat.querySelector('.gs-chat__reset');
    const history = [];
    const sessionId = window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now());

    const addMessage = (role, content, extraClass) => {
      const message = document.createElement('div');
      message.className = 'gs-message gs-message--' + role + (extraClass ? ' ' + extraClass : '');
      message.textContent = content;
      body.insertBefore(message, choices);
      body.scrollTop = body.scrollHeight;
      return message;
    };

    const ask = async (question) => {
      const clean = question.trim();
      if (!clean || submit.disabled) return;
      addMessage('user', clean);
      history.push({ role: 'user', content: clean });
      input.value = '';
      submit.disabled = true;
      const typing = addMessage('bot', 'Svarar…', 'gs-message--answer');
      try {
        const response = await fetch('https://gestaspjall.gabrieleggert04.chatgpt.site/api/chat', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ tenantId: 'demo', sessionId: sessionId, message: clean, history: history.slice(-7, -1) })
        });
        const data = await response.json();
        typing.remove();
        const answer = data.answer || data.error || 'Spjallið náði ekki sambandi. Reyndu aftur eftir smástund.';
        addMessage('bot', answer, 'gs-message--answer');
        history.push({ role: 'assistant', content: answer });
      } catch (error) {
        typing.textContent = 'Spjallið náði ekki sambandi. Reyndu aftur eftir smástund.';
      } finally {
        submit.disabled = false;
        input.focus();
      }
    };

    choices.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => ask(button.dataset.question || button.textContent || '')));
    form.addEventListener('submit', (event) => { event.preventDefault(); ask(input.value); });
    reset.addEventListener('click', () => {
      body.querySelectorAll('.gs-message--user,.gs-message--answer').forEach((message) => message.remove());
      history.length = 0;
      input.value = '';
      submit.disabled = false;
      body.scrollTop = 0;
      input.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
